export default {
    "title": "🇩🇰 Dansk",

    "首页": "Hjem",
    "关于": "Om",
    "会员": "Medlemskab",
    "推荐计划": "Henvisningsprogram",
    "个人": "Profil",
    "推荐": "Henvisning",
    "预订": "Søg nu",
    "事件": "Begivenhed",
    "登出": "Log ud",
    "登录": "Log ind",
    "注册": "Tilmeld",
    "我们的应用程序现在可用": "Vores app er nu tilgængelig",
    "为了获得更好的体验，我们刚刚推出了移动应用程序，以实现无缝、更快的预订。": "For en bedre oplevelse har vi netop lanceret vores mobilapps til problemfri og hurtigere booking.",
    "iOS版下载（即将推出）": "Download til iOS (Kommer snart)",
    "Android版下载（即将推出）": "Download til Android (Kommer snart)",
    "为什么选择我们": "Hvorfor vælge os",
    "我们卓越的服务。": "Vores fremragende tjenester.",
    "收入最高的酒店": "Mest populære ejendomme",
    "我们的合作酒店收入最高。": "Vores samarbejde omfatter de mest rentable ejendomsprojekter.",
    "回报": "Afkast",
    "最具特色的酒店": "Ejendomme med særlige funktioner",
    "我们平台上最有特色的酒店。": "De mest fremhævede ejendomme på vores platform",
    "热门国家和目的地": "Oplås eksklusive fortegnelser i Canadas bedste ejendomsområder!",
    "从我们的合作伙伴和朋友那里了解一些来自城市各地的最佳提示。": "Topcitylokationer anbefalet af eksperter og insidere.",
    "酒店": "Ejendom",
    "预订酒店并开始赚取": "Indsigt i Canadas ejendomsmarked!",
    "让我们开始与TitanTraveler一起探索世界": "Gennemsigtige data Verificerede fortegnelser Reelle muligheder.",
    "客户评价": "Udtalelser",
    "查看我们用户的真实评价。": "Tjek vores autentiske udtalelser fra vores brugere.",
    "银行卡列表": "Bankkortliste",
    "银行列表": "Bankliste",
    "持卡人姓名": "Kortholders navn",
    "银行卡号": "Bankkonto",
    "支付密码": "Betalingsadgangskode",
    "提交": "Indsend",
    "Pix列表": "Pix-liste",
    "Pix类型": "Pix-type",
    "Pix账号": "Pix-konto",
    "账号列表": "Kontoliste",
    "网络": "Netværk",
    "地址": "Adresse",
    "备注": "Note",
    "充值金额": "Genopladningsbeløb",
    "支付类型": "Betalingstype",
    "支付银行": "Betalingsbank",
    "USDT地址": "USDT-adresse",
    "二维码": "QR-kode",
    "充值渠道": "Genopladningskanal",
    "充值凭证": "Genopladningskupon",
    "立即登录": "Log ind nu",
    "用户名": "Brugernavn",
    "密码": "Adgangskode",
    "邀请码": "Invitationskode",
    "确认密码": "Bekræft adgangskode",
    "手机": "Mobil",
    "注册2": "Tilmeld",
    "金额": "Beløb",
    "新增": "Ny",
    "我们的精彩": "Vores fantastiske",
    "故事": "Historie",
    "奖项": "Priser",
    "获得": "Opnået",
    "钱包余额": "Pengepungsaldo",
    "今日奖励": "Dagens belønninger",
    "总行程": "Total ejendom",
    "访问行程": "Besøgt ejendom",
    "酒店历史": "Ejendomshistorik",
    "单价": "Pris",
    "数量": "Antal",
    "总额": "Total",
    "奖励": "Belønninger",
    "上一页": "Forrige",
    "下一页": "Næste",
    "每套预订量": "Bookinger pr. sæt",
    "预订奖励": "Bookingbelønning",
    "每日预订": "Daglig booking",
    "手机号码": "Telefonnummer",
    "修改密码": "Skift adgangskode",
    "登录密码": "Login-adgangskode",
    "当前密码": "Nuværende adgangskode",
    "新密码": "Ny adgangskode",
    "确认新密码": "Bekræft ny adgangskode",
    "保存修改": "Gem ændringer",
    "充值": "Genoplad",
    "我们的": "Vores",
    "复制": "Kopier",
    "分享链接": "Del link",
    "搜索酒店": "Søg ejendom",
    "实际等级": "Faktisk niveau",
    "升级": "Opgrader",
    "已完成预订": "Total ejendom",
    "登录时间": "Logintid",
    "信誉分": "Troværdighed",
    "控制菜单": "Dashboard-menu",
    "提现": "Udbetaling",
    "提现账号": "Udbetalingskonto",
    "你确定要删除此账号吗": "Er du sikker på, at du vil slette denne konto",
    "你确定要删除此地址吗": "Er du sikker på, at du vil slette denne adresse",
    "提示": "Tips",
    "是": "Ja",
    "否": "Nej",
    "全部": "Alle",
    "待处理": "Afventer",
    "冻结中": "Indefrosset",
    "已完成": "Fuldført",
    "订阅": "Abonner",
    "希望在我们推出新模板或更新时收到通知。 只需注册，我们就会通过电子邮件向您发送通知。": "Ønsker du at blive underrettet, når vi lancerer en ny skabelon eller en opdatering. Bare tilmeld dig, så sender vi dig en underretning via e-mail.",
    "我们的伙伴": "Vores partnere",
    "关于我们": "OM OS",
    "实时聊天支持": "Live chat-support",
    "在线聊天": "Live chat",
    "创建时间": "Oprettelsestid",
    "你确定要登出当前账号吗？": "Vil du logge ud?",
    "请输入你的邮箱": "Indtast din e-mail",
    "好评": "Meget god",
    "条评论": "Anmeldelser",
    "平均每晚": "Gns./nat",
    "旅行旅程": "Ejendomsdetaljer",
    "正在寻找酒店": "Søger efter næste ejendom",
    "开始预订": "Start",
    "旅程价格": "Ejendomspris",
    "佣金": "Provisioner",
    "底部-about": "Vi er et ejendomsmæglerbureau baseret i Toronto, Ontario, Canada, dedikeret til at promovere ejendomme i hele Canada gennem innovative, datadrevne strategier. Med personlig service og en fremadskuende, vækstorienteret tankegang hjælper vi ejendomsvirksomheder med at opnå succes. Uanset om du har brug for støtte til at accelerere virksomhedens vækst, ejendomsdesign, ejendomsadministration, strategisk planlægning eller fremtidige ejendomsudviklingsprojekter, besidder Zoocasa Real Estate ekspertisen og omfattende erfaring til at hjælpe dig med at opnå optimale resultater i denne resultatdrevne verden.",
    "立即预订": "Book nu",
    "搜索": "Søg",
    "快乐的客户": "Glade kunder",
    "快乐的酒店老板": "Glade hotelegere",
    "评论1": "Prime beliggenhed ejendom — Nyd byens bekvemmelighed, perfekt til bolig eller investering!",
    "评论2": "Kun 5 minutter til metro — Let pendling, tidsbesparende og meget effektivt liv!",
    "评论3": "Fuldt udstyret omgivelser — Indkøbscentre, topskoler og hospitaler alle inden for rækkevidde!",
    "评论4": "Frodig grønt miljø — Lavdensitets samfund, din fredelige tilflugtssted i byen!",
    "评论5": "Høj etage med åben udsigt — Uforstyrret skyline, nyd solopgang og solnedgang hver dag!",
    "评论6": "Smart layout — Lys og luftig med nord-syd eksponering, komfort i hvert hjørne!",
    "评论7": "Top skoledistrikt — Giv dit barn en forspring med fremragende uddannelsesressourcer!",
    "评论8": "Velrenommeret ejendomsadministration — 24/7 sikkerhed, smart adgangssystem og ro i sindet!",
    "评论9": "Flytteklar — Højkvalitetsfinishes, fuldt renoveret, stressfrit ejerskab!",
    "评论10": "Fremtidig vækstzone — Områdegenudvikling i gang, fremragende langsigtet værdi!",
    "评论11": "Flere funktioner til samme pris — Exceptionel værdi, dit smarte ejendomsvalg!",
    "评论12": "Sjælden mulighed — Begrænset lager, sikr et premium-aktiv, før det er væk!",
    "评论13": "Det var en anderledes oplevelse og føltes fantastisk, de lokale var meget venlige og høflige!",
    "推荐计划1": "Platformbrugere kan invitere andre til at blive platformagenter gennem henvisningskoder og blive din downline.",
    "推荐计划2": "Som upline kan du udtrække en vis procentdel af din downlines profit, og profitten opnået af upline vil blive direkte returneret til uplines platformkonto eller til teamrapporten.",
    "推荐计划3": "Bemærk: Alle agenter / downlines af platformen vil modtage en vis procentdel af platformens overskud og belønninger i overensstemmelse hermed, at udvikle et team påvirker ikke nogen agents eller downlines overskud og belønninger.",
    "评分": "Bedømmelse",
    "评论": "Kommentar",
    "酒店很棒": "Hotellet er fantastisk",
    "终于体验了，酒店非常好": "Endelig oplevede det, hotellet er meget godt",
    "我对酒店非常满意并推荐预订": "Jeg er meget tilfreds med hotellet og anbefaler booking",
    "我很高兴很满意，价格实惠": "Jeg er meget glad og tilfreds, prisen er overkommelig",
    "服务非常好，我非常喜欢": "Servicen er meget god, jeg kan virkelig lide det",
    "体验很不错，朋友已经第二次预订了": "Oplevelsen var meget god, min ven har allerede booket det for anden gang",
    "酒店环境优美": "Smukt hotelmiljø",
    "酒店卫生干净": "Hotellet er hygiejnisk og rent",
    "工作人员态度非常好": "Personaleattitude er meget god",
    "酒店服务很棒": "Hotelservice er fantastisk",
    "你还没有设置支付密码，请前往设置": "Du har ikke angivet en betalingsadgangskode, gå venligst til indstillinger",
    "订单": "Ordrer",
    "复制成功": "Kopiering vellykket",
    "团队与条件": "Vilkår og betingelser",
    "站内信": "Site-beskeder",
    "请联系客服升级会员": "Kontakt venligst kundeservice for at opgradere medlemskab",
    "我已阅读并同意": "Jeg har læst og accepteret",
    "注册协议": "Registreringsaftale",
    "忘记密码": "Glemt adgangskode",
    "账户明细": "Kontodetaljer",
    "时间": "Tid",
    "类型": "Type",
    "代理支持": "Agentsupport",
    "冻结金额": "Indefrosset beløb",
}

